// IE 2026 09 07 / ODOO-337259 (заказ Игоря): зажатый Alt — мгновенная подсказка элемента под мышью,
// без включения пункта меню «Show tooltips».
//
// Как устроено:
// - «ленивые» подсказки (директива v-wjTooltipFn, регистрируется в main.js): элемент регистрируется
//   в wijmo Tooltip с заглушкой, а КОНТЕНТ считается функцией в момент показа (App.vue, патч
//   Tooltip.prototype.show) — показ идёт при включённом «Show tooltips» или при зажатом Alt.
//   Раньше такие элементы (кнопки панели, вкладки, заголовок виджета/грида) при выключенном
//   флаге не имели подсказки вовсе — шаблон отдавал '' — и показать её по Alt было неоткуда;
// - контроллер altTooltip: keydown/keyup Alt, mousemove. При зажатом Alt для элемента под мышью
//   ищется ближайший источник подсказки: ленивая функция → зарегистрированный wijmo-тултип
//   (тег __wjTipInst ставит патч setTooltip) → ячейка грида (AttrGrid.cellTooltip — тот же текст,
//   что formatItem регистрирует при включённом флаге) — и показывается сразу. Штатные
//   mousemove-показы wijmo в это время глушатся (App.vue): иначе внешний элемент (виджет)
//   перетирал подсказку внутреннего (кнопки);
// - выключатель: настройка fe.ux.altTooltip (по умолчанию включено):
//   window.feSettings.set('fe.ux.altTooltip', false) / .reset(); счётчики — window.altTooltip.stats;
// - IE 2026 09 17 / ODOO-… (заказ Игоря «не могу навести мышку и скопировать часть текста из подсказки»):
//   отпустили Alt — подсказка НЕ гаснет мгновенно, а доживает как обычная: курсор можно перевести на неё
//   и выделить текст. Уходит, когда курсор ушёл и с элемента, и с самой подсказки (пауза
//   fe.data.altTooltipLingerGraceMs, 700 мс), по Esc, по клику мимо, по прокрутке, по потере фокуса окна
//   и по страховочному таймеру (fe.data.altTooltipLingerMaxMs, 30 с). Выключатель: fe.ux.altTooltipLinger.
// - IE 2026 09 20 / ODOO-337259 (замечание Игоря: «тултип исчезает, ещё не доведя до него … если нужно просто скрыть этот — давай скрывать затуханием через
//   некое время»): элемент подсказки у wijmo ОБЩИЙ на все инстансы, и доживающую карточку гасил любой чужой hide() — контроллер шапки грида на mouseover
//   соседней ячейки, mouseleave грида при уходе курсора на саму подсказку. Теперь, пока подсказка доживает: чужие Tooltip.hide() не действуют
//   (fe.ux.altTooltipLingerGuard); курсор ушёл с элемента и с подсказки — пауза fe.data.altTooltipLingerGraceMs (1,5 с), затем ЗАТУХАНИЕ
//   (fe.data.altTooltipFadeMs, 600 мс; 0 — без него), и пока оно идёт, подсказку ещё можно поймать — затухание отменяется; пока курсор ПРИБЛИЖАЕТСЯ к
//   подсказке, пауза отсчитывается заново (fe.ux.altTooltipApproach). Новая подсказка (Alt над другим элементом) заменяет прежнюю сразу, как раньше.
// - IE 2026 09 25 / ODOO-… (правило Игоря: подсказки только по Alt или опции): единый затвор ядра (25.09, дословно: «без опции „Показать подсказки“ не показываем
//   подсказки даже при долгом наведении на элемент; только если зажать Alt»): explainOn() — подсказка-объяснение сейчас допустима (Alt зажат | режим
//   Show tooltips | настройка базы fe.ux.hoverTooltips=true — прежнее поведение); detailsOn() — подробности (меры) бейджей наведения карты / графа /
//   потока (то же + дожитие после отпускания Alt: пауза fe.data.altTooltipLingerGraceMs + затухание fe.data.altTooltipFadeMs, как у подсказок).
//   Потребители: обёртка Tooltip.show в App.vue (статичные v-wjTooltip / setTooltip по наведению), AttrGrid.headerTooltip_over (карточка поля через
//   1,5 с), uiHelp (короткое имя по наведению), utils/nativeTitles.js (нативные title → __nativeTitle: показ по Alt — ветка в _find). Реактивность для
//   computed компонентов — store.altTipEpoch (_epoch: растёт на нажатии / отпускании Alt и на границах дожития). Счётчики stats.hoverGated / detailsLingers.
// - IE 2026 11 01 / ODOO-350449 (заказ Игоря: підказка тримається після Alt, повний текст обрізаних підписів по наведенню): источник «по точке» может отдать
//   lingerEl — элемент, на котором держится дожитие после Alt (пузырь теплокарты; без него — весь источник), и подсказка доживает как у чатов: пауза,
//   затухание, наведение в неё отменяет затухание. refresh(found) — перерисовать показанную подсказку (ответ бэка, «More») не прерывая дожития.
import { Tooltip, getElement, Rect } from '@mescius/wijmo'   // IE 2026 09 23: Rect — прямоугольник владельца для возврата подсказки, когда владелец уже перерисован

// IE 2026 09 25 / ODOO-… (правило Игоря: подсказки только по Alt или опции): короткое имя (снятый нативный title) в разметке подсказки платформы (как короткое имя uiHelp)
export const nativeTitleHtml = (s) => "<span class='ui-help-short'>" + String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;') + '</span>'

const altTooltip = {
    held: false,        // Alt зажат
    showing: false,     // идёт наш show() — пропуск через гейт в App.vue
    lastKey: null,      // ключ последнего показа (дедуп повторных show в App.vue)
    store: null,
    tip: null,          // инстанс wijmo Tooltip для ленивых подсказок (директива)
    stats: { presses: 0, shows: 0, probes: 0, ms: 0, lingers: 0, heldHides: 0, fades: 0, fadeCancels: 0, foreignHides: 0, reshows: 0, hoverGated: 0, detailsLingers: 0 },   // IE 2026 09 23: foreignHides / reshows — чужие hide() при зажатом Alt и возвраты подсказки
    _x: -1, _y: -1,
    _el: null, _inst: null, _content: null, _lastTarget: null,
    _shownInHold: false,
    holdLinger: false,   // IE 2026 09 25 / ODOO-… (заказ Игоря: форматирование строк из подсказки): полоса образцов открыта в подсказке — дожитие не завершается по уходу курсора / прокрутке / страховочному таймеру
    _installed: false,

    enabled() {
        try { return this.store?.setting?.('fe.ux.altTooltip', true) !== false } catch (e) { return true }
    },
    // IE 2026 09 17 / ODOO-… (заказ Игоря): дожитие подсказки после отпускания Alt
    lingerOn() {
        try { return this.store?.setting?.('fe.ux.altTooltipLinger', true) !== false } catch (e) { return true }
    },
    lingerGraceMs() {
        try { return +this.store?.setting?.('fe.data.altTooltipLingerGraceMs', 1500) || 1500 } catch (e) { return 1500 }   // IE 2026 09 20 / ODOO-337259: 700 → 1500
    },
    // IE 2026 09 20 / ODOO-337259: затухание перед скрытием (0 — скрывать сразу), защита от чужих скрытий, продление паузы при приближении к подсказке
    fadeMs() {
        try { const v = +this.store?.setting?.('fe.data.altTooltipFadeMs', 600); return v >= 0 ? v : 600 } catch (e) { return 600 }
    },
    guardOn() {
        try { return this.store?.setting?.('fe.ux.altTooltipLingerGuard', true) !== false } catch (e) { return true }
    },
    // IE 2026 09 23 / ODOO-… (заказ Игоря: Alt-подсказки пунктов панели): подсказка, показанная по зажатому Alt, переживает hide() чужого инстанса
    // (Tooltip.dispose при уничтожении любого FlexGrid страницы); выключатель fe.ux.altTooltipHeldGuard = false — прежнее поведение
    heldGuardOn() {
        try { return this.store?.setting?.('fe.ux.altTooltipHeldGuard', true) !== false } catch (e) { return true }
    },
    approachOn() {
        try { return this.store?.setting?.('fe.ux.altTooltipApproach', true) !== false } catch (e) { return true }
    },
    // IE 2026 09 25 / ODOO-… (правило Игоря: подсказки только по Alt или опции): единый затвор ядра: fe.ux.hoverTooltips = true — прежнее поведение (подсказки по наведению без Alt и без опции)
    hoverTipsOn() {
        try { return this.store?.setting?.('fe.ux.hoverTooltips', false) === true } catch (e) { return false }
    },
    // подсказка-объяснение допустима ПО НАВЕДЕНИЮ (без Alt): режим Show tooltips | fe.ux.hoverTooltips
    hoverExplainOn() {
        return !!this.store?.showTooltip || this.hoverTipsOn()
    },
    // подсказка-объяснение сейчас допустима: Alt зажат | по наведению (см. выше)
    explainOn() {
        return !!this.held || this.hoverExplainOn()
    },
    // подробности (меры) в бейджах наведения карты / графа / потока: то же + дожитие после отпускания Alt (пауза + затухание — как у подсказок)
    detailsOn() {
        return !!this.held || !!this._lingerEl || !!this._detailsLingerT || !!this._detailsFading || this.hoverExplainOn()
    },
    // идёт затухание подробностей (пауза после отпускания Alt прошла): компоненты вешают класс alt-details-fading
    detailsFading() {
        return !!this._detailsFading && !this.held
    },
    // реактивное эхо состояния Alt для computed компонентов (store.altTipEpoch)
    _epoch() {
        try { if (this.store) this.store.altTipEpoch = (this.store.altTipEpoch || 0) + 1 } catch (e) { /* стор ещё не установлен */ }
    },
    // дожитие подробностей после отпускания Alt: пауза (lingerGraceMs) → затухание (fadeMs; 0 — без него) → скрыть; каждая граница — эхо для computed
    _detailsLingerStart() {
        this._detailsLingerCancel()
        if (!this.lingerOn()) return
        if (this._lingerEl) { this._detailsAfterLinger = true; return }   // подсказка доживает (курсор на элементе / подсказке) — меры живут с ней; их дожитие начнёт _lingerCancel
        this.stats.detailsLingers++
        this._detailsLingerT = setTimeout(() => {
            this._detailsLingerT = null
            const fade = this.fadeMs()
            if (!(fade > 0)) { this._epoch(); return }
            this._detailsFading = true; this._epoch()
            this._detailsFadeT = setTimeout(() => { this._detailsFadeT = null; this._detailsFading = false; this._epoch() }, fade)
        }, this.lingerGraceMs())
    },
    _detailsLingerCancel() {
        if (this._detailsLingerT) { clearTimeout(this._detailsLingerT); this._detailsLingerT = null }
        if (this._detailsFadeT) { clearTimeout(this._detailsFadeT); this._detailsFadeT = null }
        this._detailsFading = false
        this._detailsAfterLinger = false
    },
    // подсказка доживает после Alt, и на это время чужие контроллеры подсказок не вмешиваются (AttrGrid.headerTooltip_over, чужие hide());
    // выключатель fe.ux.altTooltipLingerGuard = false возвращает прежнее поведение целиком
    lingering() { return !!this._lingerEl && this.guardOn() },
    lingerMaxMs() {
        try { return +this.store?.setting?.('fe.data.altTooltipLingerMaxMs', 30000) || 30000 } catch (e) { return 30000 }
    },
    resolve(fn) {
        try {
            const v = fn()
            return (v === undefined || v === null) ? '' : String(v)
        } catch (e) {
            if (!this.store?.hide_console) console.warn('altTooltip: tooltip() failed', e)
            return ''
        }
    },

    // IE 2026 09 24 / ODOO-5800: источник «по точке»: функция элемента (x, y) → { content, rect, inst, noLinger } | null (ошибка — как «нет подсказки»)
    resolveAt(node, x, y) {
        try {
            const r = node.__altTipAt(x, y)
            return (r && r.content) ? { el: node, inst: r.inst || this.tip, content: String(r.content), rect: r.rect || null, noLinger: !!r.noLinger, lingerEl: r.lingerEl || null } : null   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: підказка тримається після Alt, повний текст обрізаних підписів по наведенню): lingerEl — элемент, на котором держится дожитие (пузырь), вместо всего источника
        } catch (e) {
            if (!this.store?.hide_console) console.warn('altTooltip: point tooltip failed', e)
            return null
        }
    },

    install(store) {
        this.store = store
        if (this._installed) return
        this._installed = true
        this._onKeyDown = (e) => this.onKeyDown(e)
        this._onKeyUp = (e) => this.onKeyUp(e)
        this._onMouseMove = (e) => this.onMouseMove(e)
        this._onMouseOut = (e) => { if (this.held && !e.relatedTarget) this._hide() }
        this._onBlur = () => this.release(true)
        this._onVisibility = () => { if (document.visibilityState !== 'visible') this.release(true) }
        document.addEventListener('keydown', this._onKeyDown, true)
        document.addEventListener('keyup', this._onKeyUp, true)
        document.addEventListener('mousemove', this._onMouseMove, { capture: true, passive: true })
        document.addEventListener('mouseout', this._onMouseOut, true)
        window.addEventListener('blur', this._onBlur)
        document.addEventListener('visibilitychange', this._onVisibility)
        window.altTooltip = this
    },
    uninstall() {
        if (!this._installed) return
        this._installed = false
        document.removeEventListener('keydown', this._onKeyDown, true)
        document.removeEventListener('keyup', this._onKeyUp, true)
        document.removeEventListener('mousemove', this._onMouseMove, { capture: true })
        document.removeEventListener('mouseout', this._onMouseOut, true)
        window.removeEventListener('blur', this._onBlur)
        document.removeEventListener('visibilitychange', this._onVisibility)
        this.release()
    },

    onKeyDown(e) {
        if (e.key !== 'Alt') return
        if (e.repeat || this.held) return
        if (!this.enabled()) return
        this._lingerCancel(false)
        this.held = true
        this._detailsLingerCancel(); this._epoch()   // IE 2026 09 25 / ODOO-… (правило Игоря: подсказки только по Alt или опции)
        this._shownInHold = false
        this._lastTarget = null
        this.stats.presses++
        const t0 = performance.now()
        const target = (this._x >= 0) ? document.elementFromPoint(this._x, this._y) : null
        if (target) this.probe(target, this._x, this._y)
        this.stats.ms += performance.now() - t0
        if (this._el) e.preventDefault()
    },
    onKeyUp(e) {
        if (e.key !== 'Alt') return
        if (!this.held) return
        // показали подсказку — гасим и штатное действие браузера на одиночный Alt (фокус меню)
        if (this._shownInHold) e.preventDefault()
        this.release()
    },
    onMouseMove(e) {
        this._x = e.clientX
        this._y = e.clientY
        if (!this.held) return
        if (e.buttons) { if (this._overTooltip(e.target)) return; this._hide(); return }   // протяжка мышью — без подсказок   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: підказка пузиря групами, з кольорами категорій): нажатие внутри подсказки (кнопка «More (N)», выделение текста) её не гасит
        this.probe(e.target, e.clientX, e.clientY)
    },
    release(force = false) {
        this.held = false
        this._lastTarget = null
        // IE 2026 09 17 / ODOO-… (заказ Игоря): показанная подсказка доживает после Alt — её можно
        // «поймать» мышью и скопировать текст; force = окно потеряло фокус / вкладка скрыта
        // IE 2026 09 25 / ODOO-… (правило Игоря: подсказки только по Alt или опции): меры бейджей карты / графа / потока живут вместе с доживающей подсказкой (_detailsLingerStart
        // при _lingerEl откладывает своё дожитие до её ухода), без подсказки — дожитие мер сразу: пауза + затухание
        if (!force && this._el && this._shownInHold && this.lingerOn() && !this._noLinger) { this._lingerStart(); this._detailsLingerStart(); this._epoch(); return }   // IE 2026 09 24 / ODOO-5800: подсказка точки графика (noLinger) — отпустил Alt, скрылась
        this._hide()
        if (force) this._detailsLingerCancel(); else this._detailsLingerStart()   // IE 2026 09 25 / ODOO-… (правило Игоря: подсказки только по Alt или опции): бейджи держат меры ещё паузу + затухание
        this._epoch()
    },
    _overTooltip(node) {
        try { return !!(node && node.closest && node.closest('.wj-tooltip')) } catch (e) { return false }
    },
    _lingerStart() {
        if (this._lingerEl) return
        this._lingerEl = this._lingerHost || this._el   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: підказка тримається після Alt, повний текст обрізаних підписів по наведенню): источник «по точке» назвал свой элемент (пузырь теплокарты) — дожитие держится на нём, а не на всей области
        this._epoch()   // IE 2026 09 25 / ODOO-… (правило Игоря: подсказки только по Alt или опции)
        this.stats.lingers++
        this._lastDist = null
        this._downInTip = false
        this._lingerMove = (e) => {
            if (!this._lingerEl) return
            const t = e.target
            if (!e.buttons) this._downInTip = false
            else if (this._downInTip) return   // IE 2026 09 20 / ODOO-337259: тянут выделение текста из подсказки наружу — держим
            const over = this._overTooltip(t) || t === this._lingerEl || (this._lingerEl.contains && this._lingerEl.contains(t))
            if (over) { clearTimeout(this._lingerAway); this._lingerAway = null; this._fadeCancel(); this._lastDist = null; return }
            if (this.holdLinger) { clearTimeout(this._lingerAway); this._lingerAway = null; this._fadeCancel(); return }   // IE 2026 09 25 / ODOO-… (заказ Игоря: форматирование строк из подсказки): полоса открыта — курсор снаружи не гасит
            // IE 2026 09 20 / ODOO-337259: курсор вне элемента и подсказки. Пока он ПРИБЛИЖАЕТСЯ к подсказке, пауза отсчитывается заново и начатое затухание
            // отменяется — медленный путь к подсказке (через соседние ячейки) всегда успевает; по истечении паузы — затухание, не мгновенное скрытие
            const d = this.approachOn() ? this._distToTip(e.clientX, e.clientY) : null
            const closer = d != null && this._lastDist != null && d < this._lastDist - 0.5
            if (d != null) this._lastDist = d
            if (closer) { clearTimeout(this._lingerAway); this._lingerAway = null; this._fadeCancel() }
            if (!this._lingerAway && !this._fadeEl) this._lingerAway = setTimeout(() => { this._lingerAway = null; this._fadeStart() }, this.lingerGraceMs())
        }
        this._lingerDown = (e) => { this._downInTip = this._overTooltip(e.target); if (!this._downInTip) this._lingerCancel(true) }
        // IE 2026 09 20 / ODOO-337259: Esc, снявший доживающую подсказку, дальше не идёт — иначе App.handleKeydown (document, capture) тем же нажатием закрывал
        // АКТИВНЫЙ ВИДЖЕТ; поэтому слушатель стоит на window capture (раньше document) и гасит событие
        this._lingerKey = (e) => { if (e.key !== 'Escape' || !this._lingerEl) return; e.preventDefault(); e.stopImmediatePropagation(); this._lingerCancel(true) }
        this._lingerScroll = (e) => { if (this.holdLinger) return; if (e && this._overTooltip(e.target)) return; this._lingerCancel(true) }   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: підказка тримається після Alt, повний текст обрізаних підписів по наведенню): прокрутка внутри самой подсказки её не гасит
        // IE 2026 09 25 / ODOO-… (заказ Игоря: форматирование строк из подсказки): прокрутка (в т.ч. перерисовка гридов) не гасит открытую полосу
        document.addEventListener('mousemove', this._lingerMove, { capture: true, passive: true })
        document.addEventListener('mousedown', this._lingerDown, true)
        window.addEventListener('keydown', this._lingerKey, true)
        window.addEventListener('scroll', this._lingerScroll, true)
        this._lingerMax = setTimeout(() => this._lingerMaxFire(), this.lingerMaxMs())
    },
    // IE 2026 09 25 / ODOO-… (заказ Игоря: форматирование строк из подсказки): страховочный таймер дожития — при открытой полосе образцов взводится заново, не гасит подсказку
    _lingerMaxFire() {
        if (this.holdLinger) { this._lingerMax = setTimeout(() => this._lingerMaxFire(), this.lingerMaxMs()); return }
        this._lingerCancel(true)
    },
    _lingerCancel(hide) {
        if (!this._lingerEl) return
        clearTimeout(this._lingerAway); this._lingerAway = null
        clearTimeout(this._lingerMax); this._lingerMax = null
        clearTimeout(this._fadeTimer); this._fadeTimer = null   // IE 2026 09 20 / ODOO-337259
        document.removeEventListener('mousemove', this._lingerMove, { capture: true })
        document.removeEventListener('mousedown', this._lingerDown, true)
        window.removeEventListener('keydown', this._lingerKey, true)
        window.removeEventListener('scroll', this._lingerScroll, true)
        this._lingerEl = null
        this._epoch()   // IE 2026 09 25 / ODOO-… (правило Игоря: подсказки только по Alt или опции)
        if (this._detailsAfterLinger) { this._detailsAfterLinger = false; if (!this.held) this._detailsLingerStart() }   // IE 2026 09 25 / ODOO-… (правило Игоря: подсказки только по Alt или опции): подсказка ушла — теперь дожитие мер бейджей
        if (hide) this._hide()
        // IE 2026 09 20 / ODOO-337259: класс затухания снимается ПОСЛЕ скрытия (до него подсказка мелькнула бы на полной яркости) и снимается всегда —
        // элемент подсказки у wijmo общий, следующая подсказка приходит в него же
        this._fadeClean()
    },
    // IE 2026 09 20 / ODOO-337259: видимый элемент подсказки wijmo и расстояние от точки до него (0 — внутри)
    _tipEl() {
        try { for (const el of document.querySelectorAll('.wj-tooltip')) { const r = el.getBoundingClientRect(); if (r.width > 0 && r.height > 0) return el } } catch (e) { /* нет DOM */ }
        return null
    },
    _distToTip(x, y) {
        const el = this._tipEl()
        if (!el) return null
        const r = el.getBoundingClientRect()
        const dx = x < r.left ? r.left - x : (x > r.right ? x - r.right : 0), dy = y < r.top ? r.top - y : (y > r.bottom ? y - r.bottom : 0)
        return Math.hypot(dx, dy)
    },
    // IE 2026 09 20 / ODOO-337259 (Игорь: «давай его скрывать затуханием через некое время»): пауза вышла — подсказка гаснет плавно; курсор на подсказке или снова
    // приближается к ней — затухание отменяется и она возвращается
    _fadeStart() {
        if (!this._lingerEl) return
        const ms = this.fadeMs(), el = ms > 0 ? this._tipEl() : null
        if (!el) { this._lingerCancel(true); return }
        this._fadeEl = el
        try { el.style.setProperty('--alt-tip-fade-ms', ms + 'ms'); el.classList.add('alt-tip-fading') } catch (e) { /* элемент исчез */ }
        this.stats.fades++
        this._fadeTimer = setTimeout(() => { this._fadeTimer = null; this._lingerCancel(true) }, ms)
    },
    _fadeCancel() {
        if (!this._fadeEl) return
        clearTimeout(this._fadeTimer); this._fadeTimer = null
        this._fadeClean()
        this.stats.fadeCancels++
    },
    _fadeClean() {
        const el = this._fadeEl
        this._fadeEl = null
        if (el) { try { el.classList.remove('alt-tip-fading'); el.style.removeProperty('--alt-tip-fade-ms') } catch (e) { /* элемент исчез */ } }
    },

    // источник подсказки для элемента под мышью: ближайший вверх по DOM; пустой контент
    // (у грида нет attr.tooltip, у ячейки нет каналов) — идём дальше к родителям, как и wijmo при
    // включённом флаге (пустая регистрация = подсказки нет, показывается внешняя)
    _find(target, x, y) {
        let node = target
        while (node && node !== document.body && node.nodeType === 1) {
            // IE 2026 09 24 / ODOO-5800: источник «по точке» (__altTipAt(x, y) → { content, rect, inst, noLinger }) — график формы ячейки (utils/cellChartAlt.js)
            if (node.__altTipAt) { const at = this.resolveAt(node, x, y); if (at) return at }
            const fn = node.__wjTipFn
            if (fn) {
                const content = this.resolve(fn)
                if (content) return { el: node, inst: node.__wjTipInst || this.tip, content }
            } else if (node.__wjTipInst) {
                const content = node.__wjTipInst.getTooltip(node)
                if (content) return { el: node, inst: node.__wjTipInst, content }
            }
            if (node.classList.contains('wj-cell')) {
                const grid = node.closest('.wj-flexgrid')?.__vueGrid
                const r = grid?.cellTooltip?.(node, x, y)
                if (r?.content) return { el: node, inst: r.inst || this.tip, content: r.content, rect: r.rect || null }   // IE 2026 09 28 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U5 (доводка 28.09): rect ячейки (заголовки строк — правее колонки флажков)
            }
            // IE 2026 09 25 / ODOO-… (правило Игоря: подсказки только по Alt или опции): нативный title, снятый utils/nativeTitles.js, — по Alt коротким именем
            if (typeof node.__nativeTitle === 'string' && node.__nativeTitle) return { el: node, inst: this.tip, content: nativeTitleHtml(node.__nativeTitle) }
            node = node.parentElement
        }
        return null
    },
    probe(target, x, y) {
        if (!this.held || !target) return
        if (target.closest?.('.wj-tooltip')) return   // мышь над самой подсказкой — оставить
        if (target.closest?.('.alt-tab-panel')) { this._hide(); return }   // IE 2026 10 12 / ODOO-5800 (замечание Игоря): в листе Alt+Tab подсказок по Alt нет — Alt там зажат всегда
        const atPt = !!target.closest?.('[data-alt-tip-at]')   // IE 2026 09 24 / ODOO-5800: над источником «по точке» один элемент SVG — много точек: пересчёт на каждом движении
        if (!atPt && target === this._lastTarget && (!this._el || this._inst?.isVisible)) return
        this._lastTarget = target
        this.stats.probes++
        const found = this._find(target, x, y)
        if (!found || !found.content) { this._hide(); return }
        if (found.el === this._el && found.content === this._content && this._inst?.isVisible) return
        this._show(found)
    },
    // IE 2026 09 23 (Alt-подсказки пунктов панели): прямоугольник владельца на момент показа — по нему подсказка возвращается на прежнее место,
    // когда владелец уже перерисован (ячейка шапки грида) или отмонтирован (пункт закрывшейся панели): у отмонтированного элемента getBoundingClientRect нулевой
    _rectOf(el) {
        try { return Rect.fromBoundingRect(el.getBoundingClientRect()) } catch (e) { return null }
    },
    _show(found) {
        this._lingerCancel(false)
        this._el = found.el
        this._inst = found.inst || this.tip
        this._content = found.content
        this._rect = found.rect || this._rectOf(found.el)
        this._ptRect = found.rect || null; this._noLinger = !!found.noLinger   // IE 2026 09 24 / ODOO-5800: подсказка точки — у самой точки, без дожития
        this._lingerHost = found.lingerEl || null   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: підказка тримається після Alt, повний текст обрізаних підписів по наведенню)
        this.lastKey = null
        this.showing = true
        try { this._inst.show(found.el, found.content, found.rect || undefined) } catch (e) { /* элемент мог исчезнуть */ } finally { this.showing = false }
        this._shownInHold = true
        this.stats.shows++
    },
    // IE 2026 11 01 / ODOO-350449 (заказ Игоря: підказка тримається після Alt, повний текст обрізаних підписів по наведенню): перерисовать показанную подсказку тем же элементом (пришёл ответ бэка, раскрыли «More» в подсказке), НЕ прерывая дожития после Alt —
    // _show() снял бы его (_lingerCancel), и подсказка, в которую уже навели мышь, перестала бы уходить по уходу курсора. false — подсказки на экране нет
    refresh(found) {
        if (!found || !found.content || !this._el || !(this.held || this._lingerEl)) return false
        this._inst = found.inst || this._inst || this.tip
        this._content = String(found.content)
        if (found.rect) { this._rect = found.rect; this._ptRect = found.rect }
        if (found.lingerEl) { this._lingerHost = found.lingerEl; if (this._lingerEl) this._lingerEl = found.lingerEl }
        this._fadeCancel()
        this.lastKey = null
        this.showing = true
        try { this._inst.show(this._el, this._content, found.rect || undefined) } catch (e) { /* элемент мог исчезнуть */ } finally { this.showing = false }
        return true
    },
    _hide() {
        this._lingerCancel(false)
        if (!this._el) return
        const inst = this._inst || this.tip
        this._el = null; this._inst = null; this._content = null; this._rect = null
        this._ptRect = null; this._noLinger = false   // IE 2026 09 24 / ODOO-5800
        this._lingerHost = null   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: підказка тримається після Alt, повний текст обрізаних підписів по наведенню)
        this.lastKey = null
        try { inst.hide() } catch (e) { /* уже скрыт */ }
    },

    // IE 2026 09 23 / ODOO-… (заказ Игоря: Alt-подсказки пунктов панели): вернуть подсказку, снятую чужим hide() (Tooltip.dispose чужого контрола: он ещё и
    // обнуляет общую ссылку Tooltip._eTip, поэтому пропустить чужой hide нельзя — остался бы «призрак» без ссылки). Микрозадачей — после того как чужой
    // dispose доработал, но до отрисовки кадра: тот же элемент, тот же контент, новый общий элемент wijmo создаёт сам
    _reshow() {
        if (this._reshowQueued) return
        this._reshowQueued = true
        queueMicrotask(() => {
            this._reshowQueued = false
            if (!this._el || !(this.held || this._lingerEl)) return   // на экране: по зажатому Alt либо доживает после него
            // владелец перерисован / отмонтирован — вернуть подсказку на прежнее место по запомненному прямоугольнику (иначе wijmo поставил бы её в (0, 0))
            const rect = this._ptRect || (this._el.isConnected ? null : this._rect) || undefined   // IE 2026 09 24 / ODOO-5800: подсказка точки — у точки
            const inst = this._inst || this.tip
            try { if (inst.isVisible) return } catch (e) { /* инстанс без элемента */ }
            this.lastKey = null
            this.showing = true
            try { inst.show(this._el, this._content, rect) } catch (e) { /* элемент исчез */ } finally { this.showing = false }
            this.stats.reshows++
            // шло затухание — продолжить его на (пере)созданном элементе: show() сбрасывает классы
            if (this._fadeEl) {
                const el = this._tipEl()
                if (el) { try { el.style.setProperty('--alt-tip-fade-ms', this.fadeMs() + 'ms'); el.classList.add('alt-tip-fading') } catch (e) { /* элемент исчез */ } }
                this._fadeEl = el
            }
        })
    },
    // директива v-wjTooltipFn: значение — функция, возвращающая контент подсказки
    _bindFn(el, fn) {
        if (typeof fn === 'function') {
            el.__wjTipFn = fn
            if (!el.__wjTipReg) {
                el.__wjTipReg = true
                this.tip.setTooltip(el, '\u200b')   // заглушка (zero-width space): контент считается в момент показа
            }
        } else {
            delete el.__wjTipFn
            if (el.__wjTipReg) {
                delete el.__wjTipReg
                this.tip.setTooltip(el, null)
            }
        }
    },
}
altTooltip.tip = new Tooltip()

// тег элемента → инстанс wijmo Tooltip, где он зарегистрирован (поиск источника при Alt)
if (!Tooltip.prototype.__altTooltipPatched) {
    Tooltip.prototype.__altTooltipPatched = true
    // IE 2026 09 17 (замечание Игоря: «как только мышь уходит из ячейки шапки в промежуток до подсказки — подсказка
    // мгновенно исчезает»): wijmo сам прячет подсказку по mouseleave элемента / mousemove вне него
    // (_hideAutoTip → _checkBoundsAndHide → hide). Пока подсказка доживает после Alt, эти штатные скрытия
    // не действуют — уход решает наш контроллер (пауза, Esc, клик мимо); show/hide других подсказок не трогаем
    for (const m of ['_hideAutoTip', '_checkBoundsAndHide']) {
        const orig = Tooltip.prototype[m]
        if (typeof orig !== 'function') continue
        Tooltip.prototype[m] = function (...args) {
            if (altTooltip._lingerEl) return
            return orig.apply(this, args)
        }
    }
    // IE 2026 09 20 / ODOO-337259: элемент подсказки у wijmo общий на все инстансы — доживающую карточку гасил любой чужой hide() (контроллер шапки грида на
    // mouseover соседней ячейки, mouseleave грида, подсказка графа). Пока подсказка доживает, hide() действует только от нашего контроллера: он сначала
    // снимает признак дожития (_lingerCancel), потом прячет. Выключатель fe.ux.altTooltipLingerGuard; счётчик altTooltip.stats.heldHides
    const originalHide = Tooltip.prototype.hide
    Tooltip.prototype.hide = function (...args) {
        // IE 2026 09 23 / ODOO-… (заказ Игоря: Alt-подсказки пунктов панели): наша подсказка на экране (по ЗАЖАТОМУ Alt либо доживает после него), а hide()
        // зовёт ЧУЖОЙ инстанс — Tooltip.dispose при уничтожении любого FlexGrid страницы (замер menutip_diag.mjs: hide ← Tooltip.dispose ← FlexGrid.dispose ←
        // lhDestroyed; гриды пересоздаются постоянно), контроллер шапки грида и т.п. Пропустить чужой hide нельзя: dispose следом обнуляет общую ссылку
        // Tooltip._eTip, и элемент оставался в DOM «призраком», который наш hide() потом не находил (замер menutip_check 5a на dev02: подсказка не гасла).
        // Поэтому чужое скрытие проходит, а наша подсказка возвращается микрозадачей (_reshow) до отрисовки кадра — для глаза, как и раньше, «чужие hide()
        // не действуют». Свой инстанс при дожитии — как 20.09 (штатные скрытия wijmo не действуют); при зажатом Alt (mouseleave элемента →
        // _checkBoundsAndHide) — как раньше. Выключатели: при дожитии fe.ux.altTooltipLingerGuard, при зажатом Alt — fe.ux.altTooltipHeldGuard
        const mine = !!altTooltip._el && (altTooltip.held || !!altTooltip._lingerEl)
        const foreign = mine && this !== (altTooltip._inst || altTooltip.tip)
        if (altTooltip.lingering() && !foreign) { altTooltip.stats.heldHides++; return }
        const result = originalHide.apply(this, args)
        if (foreign && (altTooltip.held ? altTooltip.heldGuardOn() : altTooltip.guardOn())) { altTooltip.stats.foreignHides++; altTooltip._reshow() }
        return result
    }
    const originalSetTooltip = Tooltip.prototype.setTooltip
    Tooltip.prototype.setTooltip = function (el, content, position) {
        const result = originalSetTooltip.call(this, el, content, position)
        try {
            const e = getElement(el)
            if (e) {
                if (content) e.__wjTipInst = this
                else if (e.__wjTipInst === this) delete e.__wjTipInst
            }
        } catch (err) { /* тег вспомогательный */ }
        return result
    }
}

export const wjTooltipFn = {
    beforeMount(el, binding) { altTooltip._bindFn(el, binding.value) },
    updated(el, binding) { if (binding.value !== binding.oldValue) altTooltip._bindFn(el, binding.value) },
    unmounted(el) { altTooltip._bindFn(el, null) },
}

export default altTooltip
